import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function useSegmentSchema() {
  const { t } = useTranslation();

  const schema = Yup.object().shape({
    roadType: Yup.string().required(
      t("label.isRequiredValidation", {
        field: t("label.roadType"),
      })
    ),
    ifdmTimeFactor: Yup.string().required(
      t("label.isRequiredValidation", {
        field: t("label.timefactor"),
      })
    ),
    height_m: Yup.number().required(
      t("label.isRequiredValidation", {
        field: t("label.height"),
      })
    ),
    speed_km_h: Yup.number().required(
      t("label.isRequiredValidation", {
        field: t("label.speedLimit"),
      })
    ),

    vehicleCounts: Yup.array().of(
      Yup.object().shape({
        count: Yup.number().required(
          t("label.isRequiredValidation", {
            field: t("label.thisField"),
          })
        ),
      })
    ),
  });
  return schema;
}
